import script from "./Questionnairee.vue?vue&type=script&setup=true&lang=ts"
export * from "./Questionnairee.vue?vue&type=script&setup=true&lang=ts"

import "./Questionnairee.vue?vue&type=style&index=0&id=270ff70c&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-270ff70c"]])

export default __exports__